module.exports = __webpack_public_path__ + "static/profile-eb06b346562aa605d830e0640a74eca3.jpg";